const archive = document.querySelector('body.post-type-archive-besoksrapporter');

if(archive) {
  let selectedInstitutionType = new URLSearchParams(document.location.search).get('institution_type') || '';
  let selectedYear = new URLSearchParams(document.location.search).get('period') || '';
  let currentPage = parseInt(new URLSearchParams(document.location.search).get('page')) || 1;

  // SEARCH
  const searchForm = archive.querySelector('.filter-form');
  const inputField = searchForm.querySelector('input');
  const submitBtn = searchForm.querySelector('button');

  searchForm.addEventListener('submit', function(e) {
    e.preventDefault();
    e.stopPropagation();
  });

  inputField.addEventListener('search', function(e) {
    updatePage();
  });

  submitBtn.addEventListener('click', function(e) {
    e.preventDefault();
    updatePage();
  });

  if(archive.querySelector('.filter-group.period .select-options li a.selected')) {
    archive.querySelector('.filter-group.period .active-input span').innerHTML = archive.querySelector('.filter-group.period .select-options li a.selected').getAttribute('data-name');
  }

  if(archive.querySelector('.filter-group.institution_type .select-options li a.selected')) {
    archive.querySelector('.filter-group.institution_type .active-input span').innerHTML = archive.querySelector('.filter-group.institution_type .select-options li a.selected').getAttribute('data-name');
  }

  // FILTER
  const insitutionTypeSelect = archive.querySelector('.filter-group.institution_type .active-input');
  insitutionTypeSelect.addEventListener('click', function(e) {
    e.preventDefault();
    if(!this.classList.contains('open')) {
      $(this.closest('.select-input').querySelector('.select-options')).slideDown(500);
      this.classList.add('open');
      this.querySelector('button').setAttribute('aria-expanded', 'true');
      if(window.innerWidth >= 768) {
        document.querySelector('body').classList.add('no-scroll');
        $('html, body').animate({
          scrollTop: $(this).offset().top - 100
        }, 300);
      }
    }
    else {
      $(this.closest('.select-input').querySelector('.select-options')).slideUp(500);
      this.classList.remove('open');
      this.querySelector('button').setAttribute('aria-expanded', 'false');
      document.querySelector('body').classList.remove('no-scroll');
    }
  });

  const insitutionTypeOptions = archive.querySelectorAll('.filter-group.institution_type .select-options li a');
  insitutionTypeOptions.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      selectedInstitutionType = this.getAttribute('data-value');
      updatePage();
    });
  });

  const yearSelect = archive.querySelector('.filter-group.period .active-input');
  yearSelect.addEventListener('click', function(e) {
    e.preventDefault();
    if(!this.classList.contains('open')) {
      $(this.closest('.select-input').querySelector('.select-options')).slideDown(500);
      this.classList.add('open');
      this.querySelector('button').setAttribute('aria-expanded', 'true');
      if(window.innerWidth >= 768) {
        document.querySelector('body').classList.add('no-scroll');
        $('html, body').animate({
          scrollTop: $(this).offset().top - 100
        }, 300);
      }
    }
    else {
      $(this.closest('.select-input').querySelector('.select-options')).slideUp(500);
      this.classList.remove('open');
      this.querySelector('button').setAttribute('aria-expanded', 'false');
      document.querySelector('body').classList.remove('no-scroll');
    }
  });

  const yearOptions = archive.querySelectorAll('.filter-group.period .select-options li a');
  yearOptions.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      selectedYear = this.getAttribute('data-value');
      updatePage();
    });
  });

  function updatePage() {
    currentPage = 1;
    window.location.href = window.location.pathname + '?page=' + currentPage + '&sok=' + inputField.value.toLowerCase() + '&institution_type=' + selectedInstitutionType + '&period=' + selectedYear;
  }

  window.addEventListener('click', function(e) {
    if (!e.target.closest('.active-input')) {
      archive.querySelectorAll('.active-input').forEach(function(openSelect) {
        if(openSelect.classList.contains('open')) {
          $(openSelect.closest('.select-input').querySelector('.select-options')).slideUp(500);
          openSelect.classList.remove('open');
          openSelect.querySelector('button').setAttribute('aria-expanded', 'false');
        }
      });
      document.querySelector('body').classList.remove('no-scroll');
    }
  });
}